export default {
  namespaced: true,
  state: {
    isSelectedSource: false
  },
  mutations: {
    updateIsSelectedSource(state, data) {
      state.isSelectedSource = data
    }
  }
}
